import React, { PropsWithChildren } from 'react';

export function AttributeGroupFormFieldRow({ children }: PropsWithChildren) {
  return <div className="attribute-group-form__field-row">{children}</div>;
}
